import type { SVGProps } from 'react';

export const ApplePayWhiteLogo = (props: SVGProps<SVGSVGElement>) => (
    <svg width="60" height="40" viewBox="0 0 60 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M6 0.5H54C57.0376 0.500001 59.5 2.96243 59.5 6V34C59.5 37.0376 57.0376 39.5 54 39.5H6C2.96243 39.5 0.5 37.0376 0.5 34V6C0.5 2.96243 2.96243 0.5 6 0.5Z"
            fill="white"
        />
        <path
            d="M6 0.5H54C57.0376 0.500001 59.5 2.96243 59.5 6V34C59.5 37.0376 57.0376 39.5 54 39.5H6C2.96243 39.5 0.5 37.0376 0.5 34V6C0.5 2.96243 2.96243 0.5 6 0.5Z"
            stroke="#CCCCCC"
        />
        <path
            d="M36.9249 25.5594C38.2313 25.5594 39.4432 24.8895 39.9933 23.8281H40.0362V25.455H41.9615V18.7037C41.9615 16.7462 40.4144 15.4846 38.0337 15.4846C35.8248 15.4846 34.1918 16.7636 34.1317 18.521H36.0053C36.16 17.6858 36.925 17.1377 37.9735 17.1377C39.2455 17.1377 39.9589 17.738 39.9589 18.8429V19.5911L37.3633 19.7477C34.9482 19.8956 33.6418 20.8961 33.6418 22.6361C33.6418 24.3936 34.9911 25.5594 36.9249 25.5594Z"
            fill="black"
        />
        <path
            d="M44.5312 29.1439C46.5595 29.1439 47.5136 28.3608 48.3473 25.9857L52 15.6152H49.8857L47.4362 23.628H47.3932L44.9437 15.6152H42.7693L46.2931 25.4898L46.104 26.0901C45.786 27.108 45.2703 27.4995 44.3507 27.4995C44.1874 27.4995 43.8694 27.4821 43.7405 27.4647V29.0917C43.8608 29.1265 44.3765 29.1439 44.5312 29.1439Z"
            fill="black"
        />
        <path
            d="M16.7874 14.4146C15.5927 14.345 14.5699 15.1019 14.0027 15.1019C13.4268 15.1019 12.5588 14.4494 11.6133 14.4668C10.3843 14.4842 9.24119 15.1889 8.61378 16.3112C7.32457 18.5558 8.27858 21.8793 9.52482 23.7063C10.135 24.6111 10.8656 25.6029 11.8282 25.5681C12.7392 25.5333 13.1002 24.9678 14.2003 24.9678C15.3091 24.9678 15.6271 25.5681 16.5897 25.5507C17.5867 25.5333 18.2141 24.6459 18.8243 23.7411C19.5205 22.7145 19.8041 21.714 19.8213 21.6618C19.8041 21.6444 17.8961 20.9048 17.8789 18.6776C17.8617 16.8158 19.383 15.9284 19.4517 15.8762C18.5922 14.5886 17.2515 14.4494 16.7874 14.4146Z"
            fill="black"
        />
        <path
            d="M23.689 11.8915V25.455H25.7689V20.8178H28.6482C31.2781 20.8178 33.126 18.9908 33.126 16.346C33.126 13.7012 31.3125 11.8915 28.7169 11.8915H23.689Z"
            fill="black"
        />
        <path
            d="M16.0397 13.2139C15.524 13.8316 14.6989 14.3188 13.8738 14.2492C13.7707 13.414 14.1746 12.5266 14.6473 11.9785C15.163 11.3434 16.0655 10.891 16.796 10.8562C16.882 11.7262 16.5468 12.5788 16.0397 13.2139Z"
            fill="black"
        />
        <path
            d="M37.4833 23.9498C36.3746 23.9498 35.6698 23.4103 35.6698 22.5838C35.6698 21.7312 36.3488 21.2353 37.6466 21.157L39.9586 21.0091V21.7747C39.9586 23.0449 38.8928 23.9498 37.4833 23.9498Z"
            fill="white"
        />
        <path
            d="M25.7686 13.6663H28.1665C29.9714 13.6663 31.0027 14.6407 31.0027 16.3546C31.0027 18.0685 29.9714 19.0516 28.1579 19.0516H25.7686V13.6663Z"
            fill="white"
        />
    </svg>
);
